import { deepEqual } from 'fast-equals';

import ProductUtils from 'helpers/ProductUtils';

export const getAkitaKey = ({ environmentConfig: { akitaKey } }) => akitaKey;

export const getAccountApiAndCredentials = state => {
  const { environmentConfig: { api: { account } }, cookies } = state;
  return { account, credentials: cookies };
};

export const getIsAlsoBilling = ({ address: { isAlsoBilling } }) => isAlsoBilling;

export const getMafiaAndCredentials = state => {
  const { environmentConfig: { api: { mafia } }, cookies } = state;
  return { mafia, credentials: cookies };
};

export const getWasAddressValid = state => {
  const { address: { formItem } } = state;
  return deepEqual(formItem, {});
};

export const getAddressFormItem = ({ address: { formItem } }) => formItem;

export const getAddressFormItemIsBilling = ({ address: { formItem: { isBilling } } }) => isBilling;

export const getPurchaseAddresses = ({ address: { savedAddresses } }) => savedAddresses;

export const getAddressesIsLoaded = ({ address: { isLoaded } }) => isLoaded;

export const getNumberPurchaseProducts = ({ melodyCheckoutData: { purchase: { productList } } }) => productList.length;

export const getCheckoutProducts = ({ melodyCheckoutData: { purchase: { productList } } }) => productList;

export const getIsPlacingOrder = ({ melodyCheckoutData: { isPlacingOrder } }) => isPlacingOrder;

export const getPurchaseShippingAddress = ({ melodyCheckoutData: { purchase: { shippingAddressId } } }) => shippingAddressId;

export const getFormattedConstraintViolations = ({ melodyCheckoutData: { constraintViolations } }) => constraintViolations;

export const getCheckoutLinks = ({ melodyCheckoutData: { links } }) => links;

export const getPurchaseId = ({ melodyCheckoutData: { purchase: { purchaseId } } }) => purchaseId;

export const getUsePromoBalances = ({ melodyCheckoutData: { usePromoBalance } }) => usePromoBalance;

export const getCartType = ({ melodyCheckoutData: { cartType } }) => cartType;

export const getPurchaseCard = ({ melodyCheckoutData: { purchaseCreditCard } }) => purchaseCreditCard;

export const getVersionNumber = ({ melodyCheckoutData: { purchase: { versionNumber } } }) => versionNumber;

export const getPurchaseData = ({ melodyCheckoutData }) => melodyCheckoutData;

export const getUseAsDefaults = ({ melodyCheckoutData: { useAsDefaults } }) => useAsDefaults;

export const getPageType = ({ pageView: { pageType } }) => pageType;

export const getProductBrandIdProductIdPriceForAkita = ({ product: { detail: { productId, brandId, styles }, colorId } }) => ({
  'orders': [
    {
      'items': [
        {
          'brand_id': brandId,
          'product_id': productId,
          'price': ProductUtils.priceToFloat(ProductUtils.getStyleByColor(styles, colorId).price)
        }
      ]
    }
  ]
});
